export const updateFormVisibility = (formId, toInternal) => async ({
  getState,
  setState
}, {
  api
}) => {
  const {
    permissions
  } = getState();
  if (!permissions.toggleAccess) {
    return Promise.reject(new Error('no toggle access permission'));
  }
  await api.updateFormVisibility(formId, toInternal);
  setState({
    formIndex: getState().formIndex.map(formIndexItem => {
      if (formIndexItem.id !== formId) {
        return formIndexItem;
      }
      return {
        ...formIndexItem,
        internal: toInternal
      };
    })
  });
};